export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  container: "nav-container",
  logo: "nav-logo",
  home: "nav-home",
  about: "nav-about",
  philosophy: "nav-philosophy",
  services: "nav-services",
  team: "nav-team",
  contact: "nav-contact",
  cta: "nav-cta",
  mobileToggle: "nav-mobile-toggle",
};

export const CONTACT = {
  form: "contact-form",
  name: "contact-name",
  email: "contact-email",
  phone: "contact-phone",
  subject: "contact-subject",
  message: "contact-message",
  submit: "contact-submit",
  success: "contact-success",
};

export const FOOTER = {
  container: "footer-container",
  imprint: "footer-imprint",
  privacy: "footer-privacy",
  cookies: "footer-cookies",
};
